export const reasonCodeAndDescriptionRowData = () => {
    return [
        {
            id: 1,
            Description: 'Schedule Maintenance',
            Code: 'SM'
        }, {
            id: 2,
            Description: 'Unplanned Maintenance',
            Code: 'UM'
        }, {
            id: 3,
            Description: 'Turnaround',
            Code: 'TA',
        }, {
            id: 4,
            Description: 'Lack of Feed',
            Code: 'LOF'
        }, {
            id: 5,
            Description: 'Power Outage',
            Code: 'PO'
        }, {
            id: 6,
            Description: 'Process Issue',
            Code: 'PI'
        }
    ]
}